import { render, staticRenderFns } from "./alternating-current.vue?vue&type=template&id=9c64c57e&scoped=true&"
import script from "./alternating-current.vue?vue&type=script&lang=js&"
export * from "./alternating-current.vue?vue&type=script&lang=js&"
import style0 from "./alternating-current.vue?vue&type=style&index=0&id=9c64c57e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c64c57e",
  null
  
)

export default component.exports